import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Hero from '../components/Hero';
import Layout from '../components/Layout';
import Seo from '../components/SEO/PageSeo';
import Banner from '../components/Banner';
export const _frontmatter = {
  "title": "Über uns"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Layout mdxType="Layout">
  <Seo mdxType="Seo" />
  <Hero mdxType="Hero" />
    <section>
      <div className="page-center text-center">
          <h1>{`Unvernünftig hohe Preise oder unvernünftig schön?`}</h1>
          <div className="underline"></div>
          <div className="posts-center">
            <article>
Wir leben in einer Region, die ziemlich hässlich ist. Es ist eine alte
Industrieregion, die seit 20 Jahren im Niedergang begriffen ist. Es ist weit weg
vom Meer, den Bergen oder der Natur. Stattdessen sind wir umgeben von
Betonstädten, verstopften Autobahnen und grauem Himmel. Wie sind wir hierher
gekommen?
              <p>{`Die Hauspreise sind unangemessen hoch. Für den Preis einer Wohnung könnten wir woanders ein Haus mit Garten kaufen (und das hatten wir auch getan).
Also fingen wir an, nach Häusern in einer Gegend zu suchen, in der wir schon einmal gelebt haben und die wir wirklich mögen: Gironde, Frankreich.`}</p>
              <p>{`Mit Corona und Home-Office dachten wir: warum nicht ein Haus in Frankreich kaufen?`}</p>
              <h2>{`Zwei Szenarien`}</h2>
              <p>{`Heute sieht das Worst-Case-Szenario folgendermaßen aus: Wir werden ein Haus für unseren Urlaub in einer schönen Region und für unseren Ruhestand haben.
Im besten Fall haben wir dann ein Haus, in dem wir wohnen können. So oder so, für uns klingt das ziemlich toll.`}</p>
              <h3>{`Ein Haus in Frankreich finden`}</h3>
              <p>{`Im Februar 2021 begannen wir mit der Suche nach Häusern in der Nähe unseres alten Surfspots, Carcans Plage. Von den 10-15 Häusern, die wir besuchten, war keines nach unserem Geschmack.
Nicht weil sie nicht schön waren, sondern weil sie entweder auf einem Sumpf gebaut wurden oder nicht mit der Qualität, die wir erwarteten. Viele Leute bauen billige Häuser von schlechter Qualität, um sie billig zu verkaufen. Aber wir wollen ein Haus, das lange hält, also dachten wir...`}</p>
              <h3>{`Warum nicht ein Haus bauen?`}</h3>
              <p>{`Na gut, warum nicht ein Haus bauen und es so bauen lassen, wie wir es gerne hätten? Es gibt viele Gründe, warum der Bau eines Hauses großartig sein kann. Hoffentlich bekommen Sie das Haus Ihrer Träume, mit dem Grundriss, den Sie wollen, und den Farben, die Sie mögen. Und es ist brandneu und shiny.`}</p>
              <p>{`Aber ein Haus zu bauen ist auch eine Menge Stress und es gibt eine Menge Dinge, die man beachten muss.`}</p>
              <h2>{`Worum geht es in diesem Blog?`}</h2>
              <p>{`Hier stellen wir alle Phasen des Hausbaus vor, beginnend mit der Grundstückssuche, dem Bankkredit, dem ganzen Papierkram, Verträgen und allen Bauphasen. Wir werden während des gesamten Projekts Neuigkeiten und Fotos posten, bis unser Haus fertig ist. Wir haben uns für die Baufirma Maisons de la Côte (MCA) entschieden.`}</p>
            </article>
            <article>
            <Banner mdxType="Banner" />
          </article>
          </div>
        </div>
      </section>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      